import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUsuarioWithRole } from '../hooks/useUsuarioWithRole';
import { ROLES } from '../utils/roleConstants';
import AccessDenied from '../components/common/AccessDenied';

const AdminRoute = ({ children, showAccessDenied = true }) => {
  const { roleId, isLoading, error, isAdmin, isTeacher } = useUsuarioWithRole();

  // Mostrar loading mientras se carga la información del rol
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-aqua mx-auto mb-4"></div>
          <p className="text-gray-600">Verificando permisos de administración...</p>
        </div>
      </div>
    );
  }

  // Si hay error, mostrar página de acceso denegado
  if (error) {
    console.error('Error al verificar permisos de administración:', error);
    return (
      <AccessDenied
        title="Error de Verificación"
        message="No se pudo verificar tus permisos. Por favor, intenta de nuevo."
        showBackButton={true}
        showHomeButton={true}
        showProfileButton={true}
      />
    );
  }

  // Verificar si el usuario es administrador o profesor
  if (!isAdmin && !isTeacher) {
    console.warn('Acceso denegado: Se requiere rol de administrador o profesor');
    
    if (showAccessDenied) {
      return (
        <AccessDenied
          title="Acceso Denegado"
          message="Esta página solo está disponible para administradores y profesores. No tienes permisos para acceder a esta sección."
          showBackButton={true}
          showHomeButton={true}
          showProfileButton={true}
        />
      );
    }
    
    // Redirigir a cursos si no se quiere mostrar la página de acceso denegado
    return <Navigate to="/courses/getCourses" replace />;
  }

  return children || <Outlet />;
};

export default AdminRoute;
